import { MegaMenu } from './MegaMenu/MegaMenu';
import { useMediaQuery } from 'usehooks-ts';
import type { MenuConfiguration } from '@redturtle/qubicaamf-theme/types/dropdown-menu';
import { MobileMegaMenu } from './MegaMenu/MobileMegaMenu';

export type RootState = {
  navigation: {
    items: Array<{ id: string; url: string; title: string }>;
  };
  dropdownMenuNavItems: {
    result: MenuConfiguration;
  };
};

export default function Navigation({
  searchIsVisible,
}: {
  searchIsVisible: boolean;
}) {
  const isMobile = useMediaQuery('(max-width: 1199px)');

  return isMobile ? <MobileMegaMenu /> : !searchIsVisible ? <MegaMenu /> : null;
}
